module.exports = __webpack_public_path__ + "strapi-logo-06df524f84986bf6d5ece97a5f83b106.svg";